// extracted by mini-css-extract-plugin
export default {"modalSubheading":"modalSubheading__LVANw"};